import React from 'react';
import { Button } from 'primereact/button';
import { Badge } from 'primereact/badge';
import { useCart } from '../../contexts/CartContext';

const FloatingCartButton = ({ onToggleCart }) => {
    const { itemCount } = useCart();

    if (itemCount === 0) return null;

    return (
        <div 
            className="fixed z-5"
            style={{
                bottom: '100px', // Encima del botón de WhatsApp
                right: '20px'
            }}
        >
            <Button 
                icon="pi pi-shopping-cart"
                className="p-button-rounded p-button-primary p-button-icon-only shadow-4 p-overlay-badge"
                style={{
                    width: '60px',
                    height: '60px',
                    fontSize: '1.6rem'
                }}
                onClick={onToggleCart}
                tooltip="Ver carrito"
                tooltipOptions={{ position: 'left' }}
            >
                {/* Desktop: número */}
                {itemCount > 0 && (
                    <span className="hidden md:inline">
                        <Badge value={itemCount > 99 ? '99+' : itemCount} severity="danger"></Badge>
                    </span>
                )}
                {/* Móvil: punto */}
                {itemCount > 0 && (
                    <span className="inline md:hidden">
                        <Badge severity="danger"></Badge>
                    </span>
                )}
            </Button>
        </div>
    );
};

export default FloatingCartButton;